var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPageTouristAgency", {
                attrs: {
                  data: _vm.eventOrganizer,
                  cities: _vm.cities,
                  "shared-access": _vm.sharedAccess,
                  "ticket-reservations": _vm.ticketReservations,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formEventOraganizerSubmitHandler,
                  "delete-event-organizer": _vm.deleteEventOrganizer,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmEventOrganizerEmoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }